var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimpleOptimized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wipeWall",
    width: 1000,
    height: 1000,
    shapeRendering: "crispEdges",
    viewBox: "0 0 264.58 264.58",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.94 21.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "m-111.94-21.067h264.58v264.58h-264.58z",
    display: "none",
    fill: "#f00",
    strokeWidth: 0.79375
  }), /*#__PURE__*/React.createElement("g", {
    id: "wall",
    fill: "#0f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99.724-21.067h52.917v52.917h-52.917z",
    strokeWidth: 0.79375
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-111.94 190.6h158.75v52.917h-158.75z",
    strokeWidth: 1.3748
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-111.94 84.767h158.75v52.917h-158.75z",
    strokeWidth: 1.3748
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.724-21.067v158.75h-52.917v-158.75z",
    strokeWidth: 1.3748
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-111.94 137.68h52.917v52.917h-52.917z",
    strokeWidth: 0.79375
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.807 137.68h105.83v105.83h-105.83z",
    strokeWidth: 1.5875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-59.026 137.68h105.83v52.917h-105.83z",
    strokeWidth: 1.1225
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.64 31.85v105.83h-52.917v-105.83z",
    strokeWidth: 1.1225
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-59.026-21.067h105.83v105.83h-105.83z",
    strokeWidth: 1.5875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-59.026-21.067v105.83h-52.917v-105.83z",
    strokeWidth: 1.1225
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleOptimized);
export default __webpack_public_path__ + "static/media/simple-optimized.0b0fe9aa.svg";
export { ForwardRef as ReactComponent };